import { Typography, TypographyProps } from '@aloft/toolkit-sui';

import { Fragment } from 'react';

import { TdGap } from './TdGap.js';
import { PairedCostAdjustmentSummaryProps } from './types.js';

const typographyProps: Omit<TypographyProps, 'children'> = {
  variant: 'h4',
  color: 'textOffset',
};

export const PairedCostAdjustmentSummaryTableHeaderRow = ({
  isSimplifiedMode: showSummaryColumn,
  compSequence,
}: PairedCostAdjustmentSummaryProps) => (
  <tr>
    <th className="header-cell" colSpan={2}>
      <Typography {...typographyProps}>Feature</Typography>
    </th>
    {showSummaryColumn && (
      <th className="header-cell">
        <Typography {...typographyProps}>Summary</Typography>
      </th>
    )}
    {compSequence.map((compID, idx) => (
      <Fragment key={`column-title-${compID}`}>
        <TdGap isSticky={idx === 0} />
        <th className="header-cell">
          <Typography {...typographyProps}>Feature</Typography>
        </th>
        <th className="header-cell">
          <Typography {...typographyProps}>Adjustment</Typography>
        </th>
      </Fragment>
    ))}
  </tr>
);
